// Central social & platform links for The Love Genome™.
// Known URLs are live; others show as "coming soon" until URLs are provided.
export const SOCIALS = [
  { key: "linkedin_company", label: "LinkedIn — The Love Genome", url: "https://www.linkedin.com/company/the-love-genome%E2%84%A2" },
  { key: "linkedin_personal", label: "LinkedIn — Felicia Johnson", url: "https://www.linkedin.com/in/ftosinjohnson" },
  { key: "influential_women", label: "Influential Women", url: "https://influentialwomen.com/connect/felicia-johnson" },
  { key: "tiktok", label: "TikTok", url: "" },
  { key: "youtube", label: "YouTube", url: "" },
  { key: "instagram", label: "Instagram", url: "" },
  { key: "facebook", label: "Facebook", url: "" },
  { key: "x", label: "X (Twitter)", url: "" },
  { key: "github", label: "GitHub", url: "" },
  { key: "myspace", label: "Myspace", url: "" },
  { key: "medium", label: "Medium", url: "" },
  { key: "wordpress", label: "WordPress Blog", url: "" },
  { key: "blogger", label: "Blogger", url: "" },
  { key: "substack", label: "Substack", url: "" },
  { key: "podcast", label: "Podcast", url: "" },
  { key: "patreon", label: "Patreon", url: "" },
  { key: "quora", label: "Quora", url: "" },
  { key: "rss", label: "Blog RSS Feed", url: "" },
  { key: "alignable", label: "Alignable", url: "" },
];
